import { IsEnum, IsInt, IsOptional, IsString, MaxLength, Min } from 'class-validator';
import { DispatchStatus } from '../../enum';

/**
 * DTO for validating properties when updating a dispatch log entry.
 */
export class InvoiceBillingDispatchLogUpdateDto {
  /**
   * The new status for the dispatch log entry.
   * If provided, it must be one of the allowed values from the DispatchStatus enum.
   */
  @IsOptional()
  @IsEnum(DispatchStatus, {
    message: `Status must be one of the following: ${Object.values(
      DispatchStatus,
    ).join(', ')}`,
  })
  status?: DispatchStatus;

  /**
   * The number of times 'send' has been attempted.
   * If provided, it must be a non-negative integer (e.g., to reset the count to 0).
   */
  @IsOptional()
  @IsInt()
  @Min(0)
  retryCount?: number;

  /**
   * An optional error message describing the last failure.
   * If provided, it must be a string.
   */
  @IsOptional()
  @IsString()
  @MaxLength(2000)
  errorMessage?: string;
}